import { useEffect, useRef } from 'react';
import _isEqual from 'lodash/isEqual';

const deepCompareEquals = (a: any, b: any) => {
	return _isEqual(a, b);
};

const useDeepCompareMemoize = (value: any) => {
	const ref = useRef();

	if (!deepCompareEquals(value, ref.current)) {
		ref.current = value;
	}

	return ref.current;
};

const useDeepCompareEffect = (callback: any, dependencies: any) => {
	useEffect(callback, dependencies.map(useDeepCompareMemoize));
};

export default useDeepCompareEffect;
